module.exports = __webpack_public_path__ + "static/media/Tick-Box-Indeterminate-Read-Only.14a288fd.svg";